import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import cn from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import s from './UpsellWrapper.scss';
const UpsellWrapper = ({ upsellType, children, unit, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, children, /*#__PURE__*/ React.createElement(TextButton, {
        className: s['button'],
        size: "small",
        variant: "main",
        href: URLS.CORE_MEMBERSHIP,
        biData: BiData({
            evid: 375,
            referral_info: ReferralType.ADS_CORE_UPSELL,
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue
        })
    }, t(`ads.upsell.${upsellType}`)));
};
UpsellWrapper.displayName = 'UpsellWrapper';
export default UpsellWrapper;
